import React, { useState } from 'react';
import { usersService } from '../../../../services';
import { dateFns } from '../../../../helpers';
import statuses from '../../../../constants/users/statuses';
import { Box, Dialog, Button, CircularProgress } from '@mui/material';
import { RecycleBinDeleteSVG } from '../../../../components';
import { useTranslation } from 'react-i18next';
import { palette } from '../../../../styles/theme';

export function DeleteUserDialog ({ show, onHide, user, setAlert, setOpenAlert }) {
    const { t } = useTranslation();
    // State
    const [isLoading, setIsLoading] = useState(false);

    // Functions
    const deleteUser = () => {
        setIsLoading(true);

        usersService
            .toggle(user.id, {
                idStatus: statuses.inactive.id,
                // TODO Set id user logged
                idUpdatedBy: 1,
            })
            .then(() => {
                setAlert((prevAlert) => ({
                    ...prevAlert,
                    severity: 'success',
                    description: t('users.table.menu.unsubscribe.modal.success'),
                    className: 'clientsMC_Alert--success'
                }));
                setOpenAlert(true);
                setIsLoading(false);
                return true;
            })
            .catch(e => {
                setAlert((prevAlert) => ({
                    ...prevAlert,
                    severity: 'error',
                    title: t('errors.generalTitle'),
                    description: t('errors.generalDescription'),
                    className: 'clientsMC_Alert--error'
                }));
                setOpenAlert(true);
                console.error('Error on delete client', e);
                return false;
            })
            .finally(() => {
                // change state isLoading
                setIsLoading(false);
                // closing delete modal
                onHide();
            });
    };

    // Main Component
    return (
        <Dialog
            open={show}
            onClose={onHide}
            PaperProps={{ style: { padding: '32px', borderRadius: '16px', backgroundColor: palette.beige[50] } }}
        >
            <Box
                display='flex'
                justifyContent='center'
                flexDirection='column'
                gap={'40px'}
                width={'396px'} >
                <Box
                    display='flex'
                    flexDirection='column'
                    textAlign='center'
                    justifyContent='center'>
                    <Box><RecycleBinDeleteSVG /></Box>
                    <span className='delete_text-title'>¿{t('users.table.menu.unsubscribe.modal.title')} <br /><b>{` ${user?.formatted_name || ''}`}?</b></span>
                    <span className='delete_text--date'>{`${t('users.table.menu.unsubscribe.modal.date')}: ${dateFns.format(new Date(), 'dd/MM/yyyy')}`}</span>
                </Box>
                <Box
                    display='flex'
                    justifyContent='right'
                    gap='32px'>
                    <Button className='delete_button--cancel' onClick={onHide} disabled={isLoading}>
                        {t('buttons.cancel')}
                    </Button>
                    <Button className="delete_button--submit" appearance="primary" onClick={deleteUser} disabled={isLoading}>
                        {(isLoading ? <CircularProgress size={24} style={{ color: 'white' }} />
                            : t('buttons.confirm'))}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
};
